import React, {Component} from 'react';
import {Card, CardBody, CardTitle, Col, Input, Row} from 'reactstrap';
import {Colxx} from "../../../components/common/CustomBootstrap";
import IconCard from "../../../components/cards/IconCard";
import {withTranslation} from "react-i18next";
import Api from '../../../services/Api';
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {getDatePickerProps} from "../../../helpers/Utils";
import {createMuiTheme, ThemeProvider} from "@material-ui/core/styles";
import i18n from "../../../services/i18n";
import JalaliUtils from "@date-io/jalaali";
import MomentUtils from "@date-io/moment";
import fa_IR from "../../../constants/locales";
import moment from "moment";

class Stats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
      stats: null,
      from: null,
      to: null,
    };
  }

  async componentDidMount() {
    await this.fetchStatus();
  }

  fetchStatus = async () => {
    const {match} = this.props;
    const {id} = match.params;
    try {
      const {data} = await Api.invoke('GET', `/v2/admin-ui/bonusPolicies/status/${id}`);
      this.setState({
        status: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  fetchStats = async () => {
    const {from, to} = this.state;
    const {match} = this.props;
    const {id} = match.params;
    try {
      const {data} = await Api.invoke('GET', `/v2/admin-ui/bonusPolicies/stats/${id}`, null, {
        params: {
          ...(from ? {from: moment(from).toISOString()} : null),
          ...(to ? {to: moment(to).toISOString()} : null)
        },
      });
      this.setState({
        stats: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    }, this.fetchStats);
  };

  render() {
    const {from, to, stats, status} = this.state;
    const {t, match, createTime, endTime} = this.props;
    const {id} = match.params;
    return (
      <ThemeProvider
        theme={createMuiTheme({
          typography: {
            fontFamily: 'IRANSans',
          }})
        }
      >
        <MuiPickersUtilsProvider
          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
          locale={i18n.language}
        >
          <Row>
        <Colxx xxs="12">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary mb-5">
                {`${t('Bonus Card Stats')} (${id})`}
              </CardTitle>
              <Row className="px-3 mt-5 mb-4 text-one font-weight-semibold">
                آمار لحظه ای
              </Row>
              <Row className="mb-4">
                <Col className='col-12 col-md-6 col-lg-4'>
                  <IconCard
                    icon="icon-Business-Mens"
                    title={t('Activated Count')}
                    value={status ? Number(status.numActivated) : null}
                  />
                </Col>
                <Col className='col-12 col-md-6 col-lg-4'>
                  <IconCard
                    icon="icon-Money-2"
                    title={t('Trade Volume')}
                    value={status ? Number(status.vol) : null}
                  />
                </Col>
                <Col className='col-12 col-md-6 col-lg-4'>
                  <IconCard
                    icon="icon-Bulleted-List"
                    title={t('Trades Count')}
                    value={status ? Number(status.totalTrade) : null}
                  />
                </Col>
              </Row>
              <Row className="px-3 mt-5 mb-4 text-one font-weight-semibold">
                آمار در بازه زمانی دلخواه
              </Row>
              <Row className="mb-4">
                <Col className='col-6 col-lg-3'>
                  <span>{t('start date')}</span>
                  <DateTimePicker
                    {...getDatePickerProps()}
                    minDate={moment(createTime)}
                    maxDate={endTime ? moment(endTime) : undefined}
                    value={from ? from : null}
                    TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
                    onChange={date => {
                      this.handleDateChange('from', date);
                    }}
                  />
                </Col>
                <Col className='col-6 col-lg-3'>
                  <span>{t('end date')}</span>
                  <DateTimePicker
                    {...getDatePickerProps()}
                    minDate={moment(createTime)}
                    maxDate={endTime ? moment(endTime) : undefined}
                    value={to ? to : null}
                    TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
                    onChange={date => {
                      this.handleDateChange('to', date);
                    }}
                  />
                </Col>
              </Row>
              {!!stats &&
                <Row className="mb-4">
                  <Col className='col-12 col-md-6 col-lg-6'>
                    <IconCard
                      icon="icon-Money-2"
                      title={t('Trade Volume')}
                      value={Number(stats.vol)}
                    />
                  </Col>
                  <Col className='col-12 col-md-6 col-lg-6'>
                    <IconCard
                      icon="icon-Bulleted-List"
                      title={t('Trades Count')}
                      value={Number(stats.totalTrade)}
                    />
                  </Col>
                </Row>
              }
            </CardBody>
          </Card>
        </Colxx>
      </Row>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  }
}

export default withTranslation()(Stats);
